import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MyDataService {
  public fk_entity_platform: any = undefined;
  public logo: any = undefined;
  public logo2: any = undefined;
  public logo3: any = undefined;
  public user: any = undefined;

  private fkEntityPlatformSubject = new Subject<string | undefined>();
  private logoSubject = new Subject<string | undefined>();
  private logo2Subject = new Subject<string | undefined>();
  private logo3Subject = new Subject<string | undefined>();
  private userSubject = new Subject<string | undefined>();

  getFkEntityPlatformObservable(): Observable<string | undefined> {
    return this.fkEntityPlatformSubject.asObservable();
  }

  getLogoObservable(): Observable<string | undefined> {
    return this.logoSubject.asObservable();
  }

  getLogo2Observable(): Observable<string | undefined> {
    return this.logo2Subject.asObservable();
  }

  getLogo3Observable(): Observable<string | undefined> {
    return this.logo3Subject.asObservable();
  }

  getUserObservable(): Observable<any | undefined> {
    return this.userSubject.asObservable();
  }

  getFkEntityPlatform(): string {
    return this.fk_entity_platform;
  }

  setFkEntityPlatform(newValue: string): void {
    this.fk_entity_platform = newValue;
    this.fkEntityPlatformSubject.next(newValue);
  }

  getUserPlatform(): any {
    return this.user;
  }

  setUserPlatform(newValue: any): void {
    this.user = newValue;
    this.userSubject.next(newValue);
  }

  getLogo(): string {
    return this.logo;
  }

  setLogo(newValue: string): void {
    this.logo = newValue;
    this.logoSubject.next(newValue);
  }

  getLogo2(): string {
    return this.logo2;
  }

  setLogo2(newValue: string): void {
    this.logo2 = newValue;
    this.logo2Subject.next(newValue);
  }

  getLogo3(): string {
    return this.logo3;
  }

  setLogo3(newValue: string): void {
    this.logo3 = newValue;
    this.logo3Subject.next(newValue);
  }
}